import { SearchBarContext } from '@contexts';
import { useContext } from 'react';

export const useSearchBar = () => {
    return useContext(SearchBarContext);
}